import { render } from "./user-permission-model.vue?vue&type=template&id=3031be6c"
import script from "./user-permission-model.vue?vue&type=script&lang=js"
export * from "./user-permission-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__